import { AxiosError } from 'axios';
import { useState } from 'react';

// import toast from 'react-hot-toast';
import { ITableResponse } from '../models/auth/table.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../models/https';
import useHttps from './useHttps';

const useTable = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [endPage, setEndPage] = useState(1);
  const [tableData, setTableData] = useState<any>([]);

  const onTableLoadError = (err: AxiosError<ErrorHttpResponse>) => {
    // if (err?.response?.data?.message !== 'Missing authorization header') {
    //   toast.error(
    //     err?.response?.data?.message ??
    //       "Something went wrong; couldn't load table"
    //   );
    // }
    setTableData([]);
  };

  const downloadTableData = ({ data }: SuccessHttpResponse<ITableResponse>) => {
    setTableData(data.records);
    setEndPage(data.totalPages);
  };

  const fetchTableData = (link: string) => {
    const url: HttpConfig = {
      url: link,
      method: 'get',
    };

    request(url, downloadTableData, setLoading, onTableLoadError);
  };

  return { fetchTableData, loading, setLoading, tableData, endPage };
};

export default useTable;
